import { type Project, type Workspace } from '@prisma/client'
import { atom } from 'jotai'
import { type AttributeDefinitionWithAttrCountAndProjects } from '../attribute.server'
import { type ProjectWithAll } from '../project.server'

/**
 * Atom for global shared data
 *
 * Naming convention to be used: global[AtomName]Atom
 *
 */
export const globalProjectAtom = atom<Project | null>(null)

/**
 * Atom for the currently selected workspace
 */
export type GlobalWorkspace = Pick<
  Workspace,
  'id' | 'name' | 'slug' | 'description' | 'isDefault'
>
export const globalWorkspaceAtom = atom<GlobalWorkspace | null>(null)

/**
 * Workspace-scoped data atoms
 * These are automatically updated when the workspace changes
 */
export const workspaceProjectsAtom = atom<ProjectWithAll[]>([])
export const workspaceAttributeDefinitionsAtom = atom<
  AttributeDefinitionWithAttrCountAndProjects[]
>([])
export const workspaceDataLoadingAtom = atom<boolean>(false)
